<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="12"
        md="12"
      >
        <b-form
          class="needs-validation mb-1"
          @submit.prevent="submitFilter"
        >
          <b-row>
            <b-col cols="3">
              <b-form-group
                label="Tahun Pelaksanaan"
                label-for="tahunFilter"
              >
                <b-form-select
                  id="tahunFilter"
                  v-model="tahunFilter"
                  :options="dataTahunPelaksanaan"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                label="Wilayah"
                label-for="wilayahFilter"
              >
                <b-form-select
                  id="wilayahFilter"
                  v-model="wilayahFilter"
                  :options="dataWilayah"
                  :disabled="!$can('Filter', 'dashboard')"
                  @change="changeWilayah"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="PD/UPD"
                label-for="pdUpdFilter"
              >
                <v-select
                  id="kolok"
                  v-model="pdUpdFilterValue"
                  label="text"
                  :options="dataPdUpd"
                  :disabled="
                    !$can('Filter', 'dashboard') &&
                      !$can('Filter-PdUpd', 'dashboard')
                  "
                  @search="searchPdUpd"
                  @input="inputPdUpd"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              align="right"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                type="submit"
              >
                Filter
              </b-button>
            </b-col>
          </b-row>
        </b-form>

        <!-- <b-card
                    no-body
                    class="card-statistics"
                >
                    <b-card-body>
                        <b-row align-h="center" class="mb-2">

                        </b-row>
                    </b-card-body>
                </b-card> -->
        <b-card class="card-statistics">
          <b-card-body>
            <b-overlay
              :show="isLoadingChart"
              variant="light"
              opacity="0.85"
              blur="2px"
              rounded="sm"
            >
              <b-row class="match-height mb-5">
                <b-col
                  v-for="(item, i) of kalkulasiBmd"
                  :key="i"
                  xl="3"
                  sm="6"
                  :class="item.customClass"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                        size="48"
                        :variant="item.color"
                      >
                        <feather-icon
                          size="24"
                          :icon="item.icon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ item.value }}
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ item.label }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
              </b-row>
              <b-row class="match-height">
                <b-col md="3">
                  <!-- chart -->
                  <vue-apex-charts
                    ref="pieChart"
                    type="donut"
                    height="350"
                    :options="pieOptions"
                    :series="dataPie"
                  />
                </b-col>
                <b-col
                  v-for="(item, i) of kalkulasiKeberadaan"
                  :key="i"
                  xl="3"
                  sm="6"
                  :class="item.customClass"
                >
                  <b-media no-body>
                    <b-media-aside class="mr-2">
                      <b-avatar
                        size="48"
                        :variant="item.color"
                      >
                        <feather-icon
                          size="24"
                          :icon="item.icon"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body class="my-auto">
                      <h4 class="font-weight-bolder mb-0">
                        {{ item.value }}
                      </h4>
                      <b-card-text class="font-small-3 mb-0">
                        {{ item.label }}
                      </b-card-text>
                    </b-media-body>
                  </b-media>
                </b-col>
              </b-row>
            </b-overlay>
          </b-card-body>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <!-- title and subtitle -->
            <div>
              <b-card-title class="mb-1">
                Capaian Inventarisasi Per Bulan
              </b-card-title>
            </div>
            <!--/ title and subtitle -->

            <!-- badge -->
            <!-- <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
                            <h5 class="font-weight-bolder mb-0 mr-1">
                            $ 100,000
                            </h5>
                            <b-badge variant="light-secondary">
                            <feather-icon
                                icon="ArrowDownIcon"
                                size="16"
                                class="text-danger mr-25"
                            />
                            <span class="align-middle">20%</span>
                            </b-badge>
                        </div> -->
            <!--/ badge -->
          </b-card-header>

          <b-card-body>
            <b-overlay
              :show="isLoadingChart"
              variant="light"
              opacity="0.85"
              blur="2px"
              rounded="sm"
            >
              <vue-apex-charts
                type="line"
                height="400"
                :options="lineOptions"
                :series="dataCapaianInventarisasi"
              />
            </b-overlay>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body>
      <b-card-header>
        <b-card-title class="mb-1">
          Tabel Monitoring
        </b-card-title>
      </b-card-header>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entries</label>
            <v-select
              v-model="perPage"
              dir="ltr"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
              @input="inputPerPage"
            />
            <div class="align-self-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                class="mr-1"
                @click="clickPrintXl"
              >
                Print Excel
              </b-button>
            </div>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-col
                cols="9"
                md="7"
              >
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Tekan Enter"
                  @keyup.enter="keyUpSearch"
                />
              </b-col>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-overlay
        :show="isShowTable"
        variant="light"
        opacity="0.85"
        blur="2px"
        rounded="sm"
      >
        <b-table
          ref="refInvoiceListTable"
          :items="rows"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
          class="position-relative"
          small
        />
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ (currentPage - 1) * perPage + 1 }} to
                {{ currentPage * perPage }} of {{ totalRecords }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRecords"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="changePage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BButton,
  BForm,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import dashboard from '@/composables/dashboard'
import master from '@/composables/master'
import {
  generateYears, startYear, intThousand, showError,
} from '@/libs/helper'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')
    const isLoadingChart = ref(false)

    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const wilayahFilter = ref($route.query.wilayah || '')
    const tahunFilter = ref($route.query.tahun || year)
    const dataPie = ref([])
    const dataCapaianInventarisasi = ref([])
    const isShowTable = ref(true)
    const isShowTableSummary = ref(true)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') { wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10) }

    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const statusFilter = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const rows = ref([])

    const perPageSummary = ref(10)
    const totalRecordsDashboardSummary = ref(0)
    const searchQueryDashboardSummary = ref('')
    const rowsDashboardSummary = ref([])
    const currentPageSummary = ref(1)

    const pieChart = ref(null)

    const dataStatus = ref([{ value: '', text: '-- Semua --' }])

    const dataWilayah = ref([])
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const tempListYear = generateYears(startYear, year)
    tempListYear.unshift({
      text: '--Semua--',
      value: '',
    })
    const dataTahunPelaksanaan = ref(tempListYear)
    const dataDashboard = ref({
      permohonanPengukuran: [
        {
          label: 'JUMLAH BMD',
          value: 2,
          icon: 'BookOpenIcon',
          color: 'light-danger',
        },
        {
          label: 'BELUM DIINVENTARISASI',
          value: 1,
          icon: 'MainIcon',
          color: 'light-warning',
        },
        {
          label: 'SEDANG DIINVENTARISASI',
          value: 2,
          icon: 'CalendarIcon',
          color: 'light-primary',
        },
        {
          label: 'SELESAI DIINVENTARISASI',
          value: 1,
          icon: 'ArchiveIcon',
          color: 'light-success',
        },
      ],
    })
    const tableColumns = [
      { key: 'kolokSkpd', label: 'kolok skpd' },
      { key: 'nalokSkpd', label: 'kolok skpd' },
      { key: 'kolok' },
      { key: 'nalok' },
      { key: 'jumlahBmdKolok', label: 'Jml Total BMD' },
      { key: 'jumlahBelumSensus', label: 'Jml Belum Sensus' },
      {
        key: 'selesaiFaseKeberadaan',
        label: 'Tahap 1 (Selesai Fase Keberadaan)',
        class: 'text-center',
      },
      {
        key: 'persentaseSelesaiFaseKeberadaan',
        label: 'Persentase',
        class: 'text-center',
      },
      {
        key: 'selesaiFaseDataInformasi',
        label: 'Tahap 2 (Selesai Fase Data Informasi)',
        class: 'text-center',
      },
      {
        key: 'persentaseSelesaiFaseDataInformasi',
        label: 'Persentase',
        class: 'text-center',
      },
      {
        key: 'jumlahSelesaiSensusBmdBerdiriSendiri',
        label: 'Tahap 3 (Selesai QR Code)',
        class: 'text-center',
      },
      {
        key: 'persentaseSelesaiQRCode',
        label: 'Persentase',
        class: 'text-center',
      },
      {
        key: 'jumlahSelesaiSensus2',
        label: 'Selesai Sensus (Keseluruhan)',
        class: 'text-center',
      },
      {
        key: 'persentaseSelesaiSensus',
        label: 'Persentase',
        class: 'text-center',
      },
    ]
    const tableColumnsDashboardSummary = [
      { key: 'kolok' },
      { key: 'nalok' },
      { key: 'jumlahBmdKolok', label: 'Total' },
      { key: 'jumlahBelumSensus', label: 'Jumlah Belum Sensus' },
      { key: 'jumlahSedangSensus', label: 'Jumlah Sedang Sensus' },
      { key: 'jumlahSelesaiSensus', label: 'Jumlah Selesai Sensus' },
    ]

    const pieOptions = ref({
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '14px',
        fontFamily: 'Montserrat',
      },
      colors: ['#FFA1A1', '#ffe700', '#00d4bd'],
      dataLabels: {
        enabled: true,
        formatter(val) {
          // eslint-disable-next-line radix
          return `${parseInt(val)}%`
        },
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                fontSize: '2rem',
                fontFamily: 'Montserrat',
              },
              value: {
                fontSize: '1rem',
                fontFamily: 'Montserrat',
                formatter(val) {
                  // eslint-disable-next-line radix
                  return `${parseInt(val)}`
                },
              },
              total: {
                show: true,
                fontSize: '1rem',
                label: 'Total',
                formatter() {
                  return '100'
                },
              },
            },
          },
        },
      },
      labels: [
        'Belum Inventarisasi',
        'Sedang Inventarisasi',
        'Selesai Inventarisasi',
      ],
      responsive: [
        {
          breakpoint: 992,
          options: {
            chart: {
              height: 380,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
        {
          breakpoint: 576,
          options: {
            chart: {
              height: 320,
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      fontSize: '1.5rem',
                    },
                    value: {
                      fontSize: '1rem',
                    },
                    total: {
                      fontSize: '1.5rem',
                    },
                  },
                },
              },
            },
            legend: {
              show: true,
            },
          },
        },
      ],
    })

    const kalkulasiBmd = ref([
      {
        label: 'JUMLAH BMD',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-primary',
      },
      {
        label: 'BELUM INVENTARISASI',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-danger',
      },
      {
        label: 'SEDANG INVENTARISASI',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-warning',
      },
      {
        label: 'SELESAI INVENTARISASI',
        value: 0,
        icon: 'ArchiveIcon',
        color: 'light-success',
      },
    ])

    const kalkulasiKeberadaan = ref([
      {
        label: 'KEBERADAAN ADA',
        value: 2,
        icon: 'ArchiveIcon',
        color: 'light-primary',
      },
      {
        label: 'KEBERADAAN TIDAK ADA, BUKAN BIAYA/BEBAN',
        value: 2,
        icon: 'ArchiveIcon',
        color: 'light-primary',
      },
      {
        label: 'KEBERADAAN TIDAK ADA, BERUPA BIAYA/BEBAN',
        value: 2,
        icon: 'ArchiveIcon',
        color: 'light-primary',
      },
    ])

    const lineOptions = ref({
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      markers: {
        strokeWidth: 7,
        strokeOpacity: 1,
        strokeColors: [$themeColors.light],
        colors: [$themeColors.warning],
      },
      colors: [$themeColors.warning, $themeColors.success],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      tooltip: {
        custom(data) {
          return `${'<div class="px-1 py-50"><span>'}${
            data.series[data.seriesIndex][data.dataPointIndex]
          }</span></div>`
        },
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        // opposite: isRtl,
      },
    })

    const dataMeta = ref({})

    const getData = async () => {
      try {
        isLoadingChart.value = true
        let response = await dashboard.getDashboard(g, {
          kolok: pdUpdFilter.value,
          kode_wilayah: wilayahFilter.value,
        })
        const { data } = response
        const {
          jumlah_bmd: jumlahBmd,
          belum_inventarisasi: belumInventarisasi,
          sedang_inventarisasi: sedangInventarisasi,
          selesai_inventarisasi: selesaiInventarisasi,
          keberadaan_ada: keberadaanAda,
          keberadaan_tidak_ada_fisik: keberadaanTidakAdaFisik,
          keberadaan_tidak_ada_non_fisik: keberadaanTidakAdaNonFisik,
        } = data[0]

        kalkulasiBmd.value[0].value = jumlahBmd
        kalkulasiBmd.value[1].value = belumInventarisasi
        kalkulasiBmd.value[2].value = sedangInventarisasi
        kalkulasiBmd.value[3].value = selesaiInventarisasi

        kalkulasiKeberadaan.value[0].value = keberadaanAda
        kalkulasiKeberadaan.value[1].value = keberadaanTidakAdaFisik
        kalkulasiKeberadaan.value[2].value = keberadaanTidakAdaNonFisik

        pieOptions.value = {
          ...pieOptions.value,
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: '2rem',
                    fontFamily: 'Montserrat',
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`
                    },
                  },
                  total: {
                    show: true,
                    fontSize: '1rem',
                    label: 'Total',
                    formatter() {
                      return jumlahBmd
                    },
                  },
                },
              },
            },
          },
          series: [
            parseInt(belumInventarisasi, 10),
            parseInt(sedangInventarisasi, 10),
            parseInt(selesaiInventarisasi, 10),
          ],
        }

        response = await dashboard.getDashboardMonthly(g, {
          kolok: pdUpdFilter.value,
          kode_wilayah: wilayahFilter.value,
        })

        let bulanAwal = moment()
          .subtract(1, 'years')
          .endOf('month')
          .format('M')
        let tahunAwal = moment()
          .subtract(1, 'years')
          .endOf('month')
          .format('YYYY')
        bulanAwal = parseInt(bulanAwal, 10)
        tahunAwal = parseInt(tahunAwal, 10)

        let index
        const selesaiLine = []
        const sedangLine = []
        const seriesLabel = []
        for (let i = 0; i < 12; i += 1) {
          bulanAwal += 1
          if (bulanAwal > 12) {
            bulanAwal = 1
            tahunAwal += 1
          }
          index = response.data.findIndex(
            // eslint-disable-next-line no-loop-func
            item => item.bulan == bulanAwal && item.tahun == tahunAwal,
          )

          if (index < 0) {
            selesaiLine.push(0)
            sedangLine.push(0)
          } else {
            selesaiLine.push(response.data[index].selesaiInventarisasi)
            sedangLine.push(response.data[index].sedangInventarisasi)
          }

          seriesLabel.push(
            moment(`${bulanAwal}-${tahunAwal}`, 'M-YYYY').format('MM-YYYY'),
          )
        }

        lineOptions.value = {
          ...lineOptions.value,
          xaxis: {
            categories: seriesLabel,
          },
        }

        dataCapaianInventarisasi.value = [
          {
            data: selesaiLine,
            name: 'Selesai Inventarisasi',
          },
          {
            data: sedangLine,
            name: 'Sedang Inventarisasi',
          },
        ]
      } catch (error) {
        console.log(error)
      }

      isLoadingChart.value = false
    }

    // const datatable = async () => {
    //   isShowTable.value = true;

    //   let params = {
    //     filter_tahun: tahunFilter.value,
    //     filter_upd: pdUpdFilter.value,
    //     kode_wilayah: wilayahFilter.value,
    //     filter_status: statusFilter.value,
    //     length: perPage.value,
    //     start: (currentPage.value - 1) * perPage.value,
    //     cari: searchQuery.value,
    //     list: "dashboard",
    //   };
    //   let resBmd = await cetakDaftarBmd.getBmd(g, params);
    //   const { code, list, totalList } = resBmd;

    //   if (code == 200) {
    //     rows.value = list;
    //     totalRecords.value = totalList;
    //   } else {
    //     rows.value = [];
    //     totalRecords.value = 0;
    //   }

    //   isShowTable.value = false;
    // };

    const dataSummary = async () => {
      // isShowTableSummary.value = true;
      isShowTable.value = true

      const params = {
        filter_ukpd: pdUpdFilter.value,
        length: perPage.value,
        start: (currentPage.value - 1) * perPage.value,
        search: searchQuery.value,
        kode_wilayah: wilayahFilter.value,
      }
      const dashboardSummary = await dashboard.getDashboardSummary(g, params)
      const { code, list, totalList } = dashboardSummary

      if (code == 200) {
        rows.value = list.map(item => {
          const selesaiFaseKeberadaan = parseInt(item.melakukanInputPadaWeb, 10)
            + parseInt(item.belumValidasiDataInformasi, 10)
            + parseInt(item.dikembalikanValidasiDataInformasi, 10)
            + parseInt(item.belumCetakQR, 10)
            + parseInt(item.belumScanQRdanFoto, 10)
            + parseInt(item.jumlahSelesaiSensus, 10)
          const selesaiFaseDataInformasi = parseInt(item.belumCetakQR, 10)
            + parseInt(item.belumScanQRdanFoto, 10)
            + parseInt(item.jumlahSelesaiSensusBmdBerdiriSendiri, 10)
          const penyebutSelesaiFaseDataInformasi = parseInt(item.jumlahBelumSensus, 10)
            + parseInt(item.belumValidasiKeberadaan, 10)
            + parseInt(item.keberadaanDikembalikan, 10)
            + parseInt(item.melakukanInputPadaWeb, 10)
            + parseInt(item.belumValidasiDataInformasi, 10)
            + parseInt(item.dikembalikanValidasiDataInformasi, 10)
            + parseInt(item.belumCetakQR, 10)
            + parseInt(item.belumScanQRdanFoto, 10)
            + parseInt(item.jumlahSelesaiSensusBmdBerdiriSendiri, 10)
          return {
            ...item,
            selesaiFaseKeberadaan,
            persentaseSelesaiFaseKeberadaan: `${new Intl.NumberFormat('id-ID', {
              maximumFractionDigits: 2,
            }).format((selesaiFaseKeberadaan / item.jumlahBmdKolok) * 100)}%`,
            selesaiFaseDataInformasi,
            persentaseSelesaiFaseDataInformasi: `${new Intl.NumberFormat(
              'id-ID',
              {
                maximumFractionDigits: 2,
              },
            ).format(
              (selesaiFaseDataInformasi / penyebutSelesaiFaseDataInformasi)
                * 100,
            )}%`,
            persentaseSelesaiQRCode: `${new Intl.NumberFormat('id-ID', {
              maximumFractionDigits: 2,
            }).format(
              (item.jumlahSelesaiSensusBmdBerdiriSendiri
                / penyebutSelesaiFaseDataInformasi)
                * 100,
            )}%`,
            jumlahSelesaiSensus2: item.jumlahSelesaiSensus,
            persentaseSelesaiSensus: `${new Intl.NumberFormat('id-ID', {
              maximumFractionDigits: 2,
            }).format(
              (item.jumlahSelesaiSensus / item.jumlahBmdKolok) * 100,
            )}%`,
          }
        })
        totalRecords.value = totalList
      } else {
        rows.value = []
        totalRecords.value = 0
      }

      // isShowTableSummary.value = false;
      isShowTable.value = false
    }

    const submitFilter = () => {
      const url = `?wilayah=${wilayahFilter.value}&tahun=${tahunFilter.value}&pd-upd=${pdUpdFilter.value}`
      window.history.pushState('', '', url)
      getData()
      // datatable();
      dataSummary()
    }

    const getStatus = async () => {
      let tempStatus = [{ text: '-- Semua --', value: '' }]
      let resStatus = await master.getStatus(g)
      tempStatus = [...tempStatus, ...resStatus.data]

      const params = {
        list: 'unfound',
      }
      resStatus = await master.getStatus(g, params)
      tempStatus = [...tempStatus, ...resStatus.data]

      dataStatus.value = tempStatus
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    const changePage = () => {
      dataSummary()
      // datatable();
    }

    const changeStatus = () => {
      currentPage.value = 1
      dataSummary()
      // datatable();
    }

    const keyUpSearch = () => {
      currentPage.value = 1
      dataSummary()
      // datatable();
    }

    const keyUpSearchDashboardSummary = () => {
      currentPageSummary.value = 1
      dataSummary()
    }

    const inputPerPageSummary = () => {
      dataSummary()
    }

    const changePageSummary = () => {
      dataSummary()
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    const inputPerPage = () => {
      currentPage.value = 1
      // datatable();
    }

    const clickPrintXl = async () => {
      try {
        window.open(
          `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/laporan/tabel-monitoring?filter_upd=${pdUpdFilter.value}`,
          '_blank',
        )
      } catch (error) {
        console.log(error)
        showError(g, { request: error.toString() }, 'Gagal Print Excel')
      }
    }

    const numThousand = value => intThousand(value)

    // datatable();
    dataSummary()
    getData()
    getWilayah()
    getStatus()
    getPdUpd()

    return {
      perPage,
      perPageSummary,
      perPageOptions,
      searchQuery,
      searchQueryDashboardSummary,
      dataStatus,
      statusFilter,
      rows,
      rowsDashboardSummary,
      tableColumns,
      tableColumnsDashboardSummary,
      sortBy,
      isSortDirDesc,
      totalRecords,
      totalRecordsDashboardSummary,
      currentPage,
      currentPageSummary,
      isLoadingChart,
      isShowTable,
      isShowTableSummary,
      dataDashboard,
      pdUpdFilterValue,
      pdUpdFilter,
      pieOptions,
      wilayahFilter,
      tahunFilter,
      kalkulasiBmd,
      kalkulasiKeberadaan,
      lineOptions,
      dataWilayah,
      dataTahunPelaksanaan,
      dataMeta,
      dataPdUpd,
      dataPie,
      dataCapaianInventarisasi,
      changeWilayah,
      searchPdUpd,
      inputPdUpd,
      submitFilter,
      inputPerPage,
      changeStatus,
      keyUpSearch,
      keyUpSearchDashboardSummary,
      changePage,
      changePageSummary,
      inputPerPageSummary,
      clickPrintXl,
      pieChart,
      numThousand,
    }
  },
  components: {
    VueApexCharts,
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
    BForm,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
